// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3e3d12f","large":"_90fe560","rmfIcon":"_2f4c0db","small":"_13c6d58","withdrawLimit":"_62f0ad1","verifyIcon":"_60c1239"};